import i18next from 'i18next';
import globalNotification from '../common/hooks/globalNotification';
import { notificationType } from '../common/constants/notificationType';
import { IMPERSONATION_NAMESPACE } from '../common/constants/impersonation';

// Toasts raised from outside React (the axios interceptor), hence i18next directly instead of useTranslation.
// A fixed key replaces the open toast instead of stacking one per refused request.
const notify = (key, translationKey) => {
    globalNotification.open?.({
        key,
        type: notificationType.WARNING,
        message: i18next.t(`${IMPERSONATION_NAMESPACE}:${translationKey}.message`),
        description: i18next.t(`${IMPERSONATION_NAMESPACE}:${translationKey}.description`),
        placement: 'top',
    });
};

export const notifyReadOnly = () => notify('impersonation-read-only', 'read-only.toast');

export const notifyUnavailable = () => notify('impersonation-unavailable', 'unavailable');
